<template>
  <div class="categorie-container">
    <p
      v-if="Object.keys(tranches).length > 0 && displayTitle"
      class="forfait__title"
    >
      <span>
        {{ title }}
      </span>
    </p>
    <template
      v-for="(tranche, trancheKey) of tranches"
    >
      <FraisTransportTranche
        :key="'range' + trancheKey"
        :tranche="tranche"
        @deleteForfait="deleteForfait"
        @updateForfait="updateForfait"
      />
    </template>
  </div>
</template>
<script>
import FraisTransportTranche from './FraisTransportTranche.vue'
export default {
  components: {
    FraisTransportTranche
  },
  props: {
    tranches: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: 'Forfait par défaut'
    },
    displayTitle: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    deleteForfait(forfaitId) {
      this.$emit('deleteForfait', forfaitId)
    },
    updateForfait(forfait) {
      this.$emit('updateForfait', forfait)
    }
  }
}
</script>

<style scoped>
  .categorie-container {
    background-color: #dddddd;
  }
  .forfait__title {
    margin: 0;
    padding: 6px;
    font-size: 13px;
  }
</style>
